export default {
  noComments: 'No tiene comentarios.',
  addComment: 'Agregar Comentario',
  observationSaved: 'Observación guardada.',
  observationUpdated: 'Observación modificada.',
  commentSaved: 'Comentario guardado.',
  commentUpdated: 'Comentario actualizado.',
};
